<template>
  <div
    :title="label"
    :style="{
      zIndex,
      ...position ? {
        left: pixels(position[0]),
        top: pixels(position[1])
      } : {}
    }"
    :class="[
      $style.component,
      'animate__animated',
      isAnimatingRight && 'animate__bounce',
      isAnimatingWrong && 'animate__headShake'
    ]"
    @animationend="onAnimationEnd"
  >
    <ItemGraphics
      :imageUrl="imageUrl"
      :label="label"
      :size="size"
    />
  </div>
</template>

<script>
import {ref} from '@vue/composition-api'

export default {
  props: {
    label: {type: String, required: false},
    imageUrl: {type: String, required: false},
    size: {type: Array, required: false},
    position: {type: Array, required: false},
    zIndex: {type: Number, required: false},
  },
  setup () {
    const isAnimatingRight = ref(false)
    const isAnimatingWrong = ref(false)

    return {
      isAnimatingRight,
      isAnimatingWrong,
      animateRight () {
        isAnimatingRight.value = true
        isAnimatingWrong.value = false
      },
      animateWrong () {
        isAnimatingRight.value = false
        isAnimatingWrong.value = true
      },
      onAnimationEnd () {
        isAnimatingRight.value = false
        isAnimatingWrong.value = false
      },
      pixels (val) {
        if (typeof val === 'number') return val + 'px'
        return val
      },
    }
  },
}
</script>

<style module lang="scss">
.component {
  position: absolute;
  user-select: none;
  -webkit-user-drag: none;

  > * {
    transform: translate(-50%, -50%);
  }
}
</style>
